/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { PraticaComunicazioneEsitoDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface ListPraticaComunicazioniRequestParams {
    idTipoPratica: string;
    idPratica: string;
}


export interface GestioneComunicazioniPraticaServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Elenco (non paginato) delle comunicazioni della pratica, dalla più recente. Lista vuota se nessuna comunicazione e\&#39; mai stata accodata. 5 stati possibili: PENDENTE, IN_CORSO, INVIATA, FALLITA_DEFINITIVA, SALTATA_NO_RECAPITO.
     * 
     * @endpoint get /api/v1/gestione/tipi-pratica/{idTipoPratica}/pratiche/{idPratica}/comunicazioni
* @param requestParameters
     */
    listPraticaComunicazioni(requestParameters: ListPraticaComunicazioniRequestParams, extraHttpRequestParams?: any): Observable<Array<PraticaComunicazioneEsitoDTO>>;

}
